export const version = '2.12.1';
//# sourceMappingURL=version.js.map